import { startPresenterPerformanceTelemetry } from '@/utils/presenter-performance/presenterPerformanceTelemetry'

const buildContext = (store) => {
  const { state } = store
  return {
    presentationId: state.presentation?.id ?? null,
    slideId: state.slideActive?.id ?? null,
    slideType: state.slideActive?.type ?? null,
    audienceCount: state.userOnline || 0,
    chatEnabled: Boolean(state.presentation?.isEnableChat),
  }
}

// Required lazily: these modules import the store, which is still being built when this plugin is registered.
const trackEvent = (eventName, properties) => {
  // eslint-disable-next-line global-require
  require('@/utils/mixpanel.utils').default.track(eventName, properties)
}

// addListener (not on) so the client proxy's message wrapper does not stop removeListener matching.
const subscribeMqtt = (onMessage) => {
  // eslint-disable-next-line global-require
  const mqttClient = require('@/mqtt/mqtt.client').default
  mqttClient.addListener('message', onMessage)
  return () => mqttClient.removeListener('message', onMessage)
}

const subscribeSocket = (onMessage) => {
  // eslint-disable-next-line global-require
  const Socket = require('@/socket').default
  const socket = Socket.getSocket()
  if (!socket || !socket.onAny) return undefined
  socket.onAny(onMessage)
  return () => socket.offAny(onMessage)
}

const presenterPerformancePlugin = (store) => {
  let stopTelemetry = null

  store.watch(
    (_state, getters) => Boolean(getters.isPresenting && getters['featureToggles/canUsePresenterPerformanceTelemetry']),
    (shouldRun) => {
      if (shouldRun && !stopTelemetry) {
        try {
          // eslint-disable-next-line global-require
          stopTelemetry = require('@/services/flagGate').runFlagged('PRE-210-presenter-performance-telemetry', () => startPresenterPerformanceTelemetry({
            getContext: () => buildContext(store),
            track: trackEvent,
            inboundCounters: { mqtt: subscribeMqtt, socket: subscribeSocket },
          }))
        } catch {
          stopTelemetry = null
        }
      } else if (!shouldRun && stopTelemetry) {
        stopTelemetry()
        stopTelemetry = null
      }
    },
    { immediate: true },
  )
}

export default presenterPerformancePlugin
